import { render, staticRenderFns } from "./sidebarMenuShrink.vue?vue&type=template&id=2e09aa7e"
import script from "./sidebarMenuShrink.vue?vue&type=script&lang=js"
export * from "./sidebarMenuShrink.vue?vue&type=script&lang=js"
import style0 from "./sidebarMenuShrink.vue?vue&type=style&index=0&id=2e09aa7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports